(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.campaign = {
  CONSTANTS: {},
  openCampaignApi: {},
  asyncOpenCampaignApi: {},
  campaignApi: {},
  asyncCampaignApi: {},
  internal: {}
};
svs.numbergames.campaign.logger = new svs.core.log.Logger('numbergames:campaing');

 })(window);